import { useState } from "react";
import { 
  DndContext, 
  DragOverlay, 
  useSensor, 
  useSensors, 
  MouseSensor, 
  TouchSensor,
  closestCorners 
} from "@dnd-kit/core";
import { STAGES } from "./constants";
import KanbanColumn from "./KanbanColumn";
import KanbanCard from "./KanbanCard";

// ═══════════════════════════════════════════════════════════
// CRM KANBAN BOARD
// ═══════════════════════════════════════════════════════════
export default function CrmKanban({
  opps,
  onCardClick,
  onCreateNew,
  onEditOpp,
  onDeleteOpp,
  onArchiveOpp,
  onStageChange,
}) {
  const [activeId, setActiveId] = useState(null);

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 250, tolerance: 5 } })
  );

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    
    if (over && active.id !== over.id) {
      // If dropped on a column (which has id = stage name)
      // Check if the over.id is a stage name
      if (STAGES.includes(over.id)) {
        // Only update if stage is different
        const currentOpp = opps.find(o => o.id === active.id);
        if (currentOpp && currentOpp.stage !== over.id) {
          onStageChange && onStageChange(active.id, over.id);
        }
      }
    }
    setActiveId(null);
  };

  const activeOpp = activeId ? opps.find(o => o.id === activeId) : null;

  return (
    <DndContext 
      sensors={sensors} 
      collisionDetection={closestCorners} 
      onDragStart={handleDragStart} 
      onDragEnd={handleDragEnd}
    >
      <div style={{
        display: "flex", gap: "10px",
        padding: "14px 20px 20px",
        overflowX: "auto", overflowY: "hidden",
        height: "calc(100vh - 147px)",
        alignItems: "flex-start",
      }}>
        {STAGES.map(stage => (
          <KanbanColumn
            key={stage}
            stage={stage}
            opps={opps.filter(o => o.stage === stage)}
            onCardClick={onCardClick}
            onCreateNew={onCreateNew}
            onEditOpp={onEditOpp}
            onDeleteOpp={onDeleteOpp}
            onArchiveOpp={onArchiveOpp}
          />
        ))}

        {/* Add Stage column placeholder */}
        <div style={{
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "flex-start",
          paddingTop: "12px", minWidth: "48px",
        }}>
          <button style={{
            width: "36px", height: "36px", border: "1.5px dashed #c8c8e0",
            borderRadius: "9px", background: "transparent", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#b0b0c8", transition: "all .15s",
            fontSize: "11px",
          }}
            title="Add Stage"
            onMouseEnter={e => { e.currentTarget.style.borderColor = "#0f3460"; e.currentTarget.style.color = "#0f3460"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "#c8c8e0"; e.currentTarget.style.color = "#b0b0c8"; }}
          >
            +
          </button>
          <span style={{ fontSize: "9px", color: "#b0b0c8", marginTop: "4px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.3px" }}>
            Stage
          </span>
        </div>
      </div>

      <DragOverlay>
        {activeOpp ? (
          <div style={{ transform: "rotate(3deg)", width: "220px" }}> 
            <KanbanCard 
              opp={activeOpp} 
              isOverlay 
            />
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  );
}
